"use client";

import { Text } from "@/components/ui/text";
import { TextProps } from "@/components/ui/text/text";
import { Icon, IconProps } from "@/components/ui/icon";
import { ArtDirection } from "@/components/util/art-direction";
import { Video } from "@/components/util/video";
import ResourceItemIcon from "./resource-item-icon";

import { useResourceItem, UseResourceItemProps } from "./use-resource-item";

export type ResourceItemProps = UseResourceItemProps;

function ResourceItem(props: ResourceItemProps) {
  const {
    styles,
    data: { title, description, media, legend },
    textSize,
    iconName,
    isVideoBackground,
    hasCustomIcon,
    onClick,
    isLoading,
  } = useResourceItem(props);

  return (
    <article className={styles.base()}>
      <button type="button" className={styles.wrapper()} onClick={onClick}>
        {legend && (
          <Text tag="span" size="labelSmall" className={styles.legend()}>
            {legend}
          </Text>
        )}

        <div className={styles.cardMediaWrapper()}>
          {hasCustomIcon && iconName && (
            <span className={styles.customIconWrapper()}>
              <ResourceItemIcon
                iconName={iconName}
                styles={styles}
                isLoading={isLoading}
              />
            </span>
          )}
          {isVideoBackground && (
            <Video
              className={styles.media()}
              containerClassName={styles.mediaWrapper()}
              src={media?.url || ""}
              mime={media?.mime || ""}
              autoPlay
              muted
              loop
              playsInline
            />
          )}
          <ArtDirection
            className={styles.media()}
            containerClassName={styles.mediaWrapper()}
            desktop={media}
          />
        </div>

        <div className={styles.content()}>
          {title && (
            <Text
              tag="h4"
              size={textSize.title as TextProps["size"]}
              className={styles.title()}
            >
              {title}
            </Text>
          )}
          {description && (
            <Text
              size={textSize.description as TextProps["size"]}
              className={styles.description()}
            >
              {description}
            </Text>
          )}
          {iconName && (
            <span className={styles.iconWrapper()}>
              <ResourceItemIcon
                iconName={iconName}
                styles={styles}
                isLoading={isLoading}
              />
            </span>
          )}
        </div>
      </button>
    </article>
  );
}

export default ResourceItem;
